<template>
  <keep-alive>
      <SimCardProfileList />
  </keep-alive>
</template>
<script>
import SimCardProfileList from './SimCardProfileList/SimCardProfileList.vue'
export default {
  components: {
    SimCardProfileList
  }
}
</script>
